export default "__VITE_ASSET__Delk418M__"